import React from 'react'
import { AlertBottomStyle, CloseButton, Content } from './style'
import { useDispatch, useSelector } from 'react-redux'
import { Icon } from '../../Icon'
import { setAlertBottomStatus } from 'store/root-slices'
import { stopPropagation } from 'utils/common'

const AlertBottom = (props) => {
	const { shopProperties, alertBottom } = useSelector((state) => state.root)
	const dispatch = useDispatch()

	return (
		<AlertBottomStyle alertBottom={alertBottom} onClick={stopPropagation}>
			<CloseButton
				onClick={() => dispatch(setAlertBottomStatus('close'))}
			>
				<Icon component='close' />
			</CloseButton>
			<Content>
				Can’t see your order or having problems registering your return?
				Contact {shopProperties['shop.name']}{' '}
				<a
					href={'mailto:' + shopProperties['shop.support.email']}
					target='_blank'
					rel='noopener noreferrer'
				>
					{shopProperties['shop.support.email']}
				</a>
			</Content>
		</AlertBottomStyle>
	)
}
export default AlertBottom
